import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <main className="app-content">
      <section className="card card--lg empty-state" style={{ minHeight: 360 }}>
        <div className="col" style={{ alignItems: 'center', gap: 12 }}>
          <span
            style={{
              width: 44,
              height: 44,
              borderRadius: 14,
              background: 'var(--accent-soft)',
              color: 'var(--accent-strong)',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <Compass size={18} />
          </span>
          <h2 style={{ margin: 0, fontWeight: 600, letterSpacing: '-0.01em' }}>
            That route doesn&apos;t exist
          </h2>
          <div className="muted" style={{ fontSize: 13 }}>
            The link you followed may be stale, or the feature is still upcoming.
          </div>
          <Link to="/dashboard" className="btn btn--primary" style={{ marginTop: 8 }}>
            Back to dashboard
          </Link>
        </div>
      </section>
    </main>
  )
}
